export default __webpack_public_path__ + "static/hero-video-2-2868b31494c552fb5e00c8a963c02b15.mp4";